'use strict';

const { defineCustomElements } = require('vviinn-widgets/dist/cjs/loader.cjs.js');

defineCustomElements(window);
